// Utilitaires de contact : liens cliquables téléphone (WhatsApp) et email

// Convertit un numéro FR (ex: "06 22 36 01 90" ou "+33 6 22 36 01 90") en URL WhatsApp
export const phoneToWhatsAppUrl = (phone) => {
  if (!phone) return null;
  let digits = String(phone).replace(/\D/g, '');
  // Retirer un éventuel préfixe international déjà présent
  if (digits.startsWith('0033')) digits = digits.slice(2);
  if (digits.startsWith('0')) digits = '33' + digits.slice(1);
  return `https://wa.me/${digits}`;
};

// Lien mailto propre
export const emailToMailto = (email) => (email ? `mailto:${email}` : null);
